import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { AppTextService } from '../app-text';

@Component({
    selector: 'fi-button-back-new',
    template: `
        <button mat-icon-button class="show-mobile BrandedColor" (click)="back()">
            <mat-icon class="fa fa-chevron-left"></mat-icon>
        </button>
        <button mat-raised-button class="hide-mobile btn-default" (click)="back()">
            {{ buttonTitle }}
        </button>
    `,
    styleUrls: ['./fi-button-back-new.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-button-back-new' },
    standalone: false,
})
export class FiButtonBackNewComponent {
    @Input() buttonTitle: String = this.appTextService.get('back');

    constructor(private appTextService: AppTextService) {}

    back() {
        window.history.back();
    }
}
